(function () {
  var SOURCE = '.announcement-text-change'; 
  var TARGET = '.announcement__content';    
  function sync() {
    var targets = document.querySelectorAll(TARGET);
    if (!targets.length) return;
    var source = document.querySelector(SOURCE);
    if (!source) {
      targets.forEach(function (t) {
        if (t.dataset.originalHtml !== undefined) {
          t.innerHTML = t.dataset.originalHtml;
          delete t.dataset.originalHtml;
        }
      });
      return;
    }
    var html = source.innerHTML.trim();
    if (!html) return; 
    targets.forEach(function (t) {
      if (t.dataset.originalHtml === undefined) t.dataset.originalHtml = t.innerHTML;
      if (t.innerHTML !== html) t.innerHTML = html; 
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  window.addEventListener('load', sync); 
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('shopify:section:unload', function () { setTimeout(sync, 0); });
})();